import React, { useState } from "react";
import Snackbar from "components/ui/atoms/Snackbar";

export const SnackbarContext = React.createContext();

const INITIAL_STATE = {
  messageLeft: undefined,
  messageRight: undefined,
  open: false,
  variant: undefined,
};

const SnackbarProvider = ({ children }) => {
  const [state, setState] = useState(INITIAL_STATE);

  const displayMessage = (messageLeft, messageRight, variant) => {
    setState({
      messageLeft: messageLeft,
      messageRight: messageRight,
      variant: variant,
      open: true,
    });
  };

  const closeSnackbar = () => {
    setState(INITIAL_STATE);
  };

  const displayError = (error) => {
    try {
      if (typeof error === "string" || error instanceof String)
        displayMessage("Error: " + error, <>&#10060;</>, "error");
      else if (error.response?.status == 400) {
        // We can suppose it is an API ERROR
        displayMessage(
          <>
            <b>Error</b>
            <ul>
              {Object.entries(error.response.data).map(
                ([errorTitle, label]) => (
                  <li key="{errorTitle}">
                    <b>{errorTitle}: </b>
                    <span>{JSON.stringify(label)}</span>
                  </li>
                ),
              )}
            </ul>
          </>,
          <></>,
          "error",
        );
      } else if (
        typeof error.message === "string" ||
        error.message instanceof String
      )
        displayMessage("Error: " + error.message, <>&#10060;</>, "error");
      else if (error.response.headers["content-type"] == "text/html")
        displayMessage(
          "Full error message in response body.",
          <>&#10060;</>,
          "error",
        );
      else if (error.response.data.detail)
        displayMessage(
          <span
            dangerouslySetInnerHTML={{ __html: error.response.data.detail }}
          ></span>,
          <>&#10060;</>,
          "error",
        );
      else {
        console.log(error);
        displayMessage("Error, see console.", <>&#10060;</>, "error");
      }
    } catch (innerError) {
      console.log(innerError);
      console.error(error);
      displayMessage("Error, see console.", <>&#10060;</>, "error");
    }
  };

  return (
    <SnackbarContext.Provider value={{ state, displayMessage, displayError }}>
      {state.open && (
        <Snackbar
          open={state.open}
          messageLeft={state.messageLeft}
          messageRight={state.messageRight}
          onClose={closeSnackbar}
          variant={state.variant}
        />
      )}
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
